<div class="container-fluid bg-white vh-100 p-0">
    <div class="d-flex flex-column align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
                <span><i class="text-muted bi bi-question-circle me-3"></i></span>
                <span class="text-muted text-xs">
                    Please provide your current employment information. This helps us assess your financial stability
                    and determine appropriate financing options.
                </span>
            </div>

            <div class="form-group mt-4">
                <div class="mb-4 p-3 border rounded shadow-sm">
                    <h5 class="fw-bold mb-3">Employment Details</h5>

                    <!-- Employment Type -->
                    <label class="fw-bold text-xs text-start d-block mt-3">Are you employed? <span
                            class="text-danger">*</span></label>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="client_employment_type" id="employed"
                            value="EMPLOYED" />
                        <label class="form-check-label text-xs" for="employed">Employed</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="client_employment_type" id="self_employed"
                            value="SELF-EMPLOYED" />
                        <label class="form-check-label text-xs" for="self_employed">Self-Employed</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="client_employment_type" id="unemployed"
                            value="UNEMPLOYED" />
                        <label class="form-check-label text-xs" for="unemployed">Unemployed</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="client_employment_type" id="retired"
                            value="RETIRED" />
                        <label class="form-check-label text-xs" for="retired">Retired</label>
                    </div>
                    <small v-if="error_messages.client_employment_type" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_type }}
                    </small>

                    <div v-if="is_employed">
                        <!-- Current Employment Start Date --> 
                        <label for="client_current_employment_start_date" class="fw-bold text-xs text-start d-block mt-3">Current Employment Start Date
                            <span class="text-danger">*</span>
                        </label>
                        <input v-model="client_current_employment_start_date" type="date"
                            class="form-control rounded-small shadow-sm w-100" id="client_current_employment_start_date" />
                        <small v-if="error_messages.client_current_employment_start_date" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_current_employment_start_date }}
                        </small>

                        <!-- Occupation -->
                        <label for="occupation" class="fw-bold text-xs text-start d-block mt-3">Occupation
                            <span class="text-danger">*</span>
                        </label>
                        <select v-model="client_occupation" class="form-select rounded-small text-xs"
                            required>
                            <option value="" selected disabled hidden>Select Occupation</option>
                            <option v-for="option in occupation_options" :value="option.value" :key="option.value">
                                {{ option.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_occupation" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_occupation }}
                        </small>

                        <!-- Industry Sector -->
                        <label for="industry_sector" class="fw-bold text-xs text-start d-block mt-3">Industry Sector
                            <span class="text-danger">*</span>
                        </label>
                        <select v-model="client_industry_sector" class="form-select rounded-small text-xs">
                            <option value="" selected disabled hidden>Select Industry Sector</option>
                            <option v-for="sector in industry_sector_options" :key="sector.value" :value="sector.value">
                                {{ sector.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_industry_sector" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_industry_sector }}
                        </small>

                        <!-- Type of Industry -->
                        <label for="industry_type" class="fw-bold text-xs text-start d-block mt-3">Type of Industry
                            <span class="text-danger">*</span>
                        </label>
                        <select v-model="client_industry" class="form-select rounded-small text-xs">
                            <option value="" selected disabled hidden>Select Type of Industry</option>
                            <option v-for="industry in industry_options" :key="industry.value" :value="industry.value">
                                {{ industry.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_industry" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_industry }}
                        </small>

                        <!-- Professional Indicator -->
                        <label class="fw-bold text-xs text-start d-block mt-3">Are you a Professional?
                            <span class="text-danger">*</span>
                        </label>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" v-model="client_professional_ind"
                                id="professional_yes" value="YES" name="professional">
                            <label class="form-check-label text-xs" for="professional_yes">Yes</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" v-model="client_professional_ind"
                                id="professional_no" value="NO" name="professional">
                            <label class="form-check-label text-xs" for="professional_no">No</label>
                        </div>
                        <small v-if="error_messages.client_professional_ind" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_professional_ind }}
                        </small>

                        <!-- Occupation Level -->
                        <label class="fw-bold text-xs text-start d-block mt-3">Occupation Level
                            <span class="text-danger">*</span>
                        </label>
                        <select v-model="client_occupation_level" class="form-select rounded-small text-xs">
                            <option value="" selected disabled hidden>Select Occupation Level</option>
                            <option v-for="level in occupation_level_options" :key="level.value" :value="level.value">
                                {{ level.label }}
                            </option>
                        </select>
                        <small v-if="error_messages.client_occupation_level" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_occupation_level }}
                        </small>

                        <!-- Employer Name -->
                        <label for="employer_name" class="fw-bold text-xs text-start d-block mt-3">Employer Name
                            <span class="text-danger">*</span>
                        </label>
                        <input v-model="client_employer_name" type="text"
                            class="form-control rounded-small shadow-sm w-100" id="employer_name"
                            placeholder="Enter employer name" maxlength="50" />
                        <small v-if="error_messages.client_employer_name" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_employer_name }}
                        </small>

                        <!-- Telephone Number -->
                        <label for="work_telephone" class="fw-bold text-xs text-start d-block mt-3">Work Telephone
                            Number
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex">
                            <input v-model="client_work_telephone_code" type="text"
                                class="form-control rounded-small shadow-sm me-2 input-telephone-code"
                                id="work_telephone_code" placeholder="Code" />
                            <input v-model="client_work_telephone_number" type="text"
                                class="form-control rounded-small shadow-sm flex-grow-1" id="work_telephone"
                                placeholder="Number" />
                        </div>
                        <small v-if="error_messages.client_work_telephone_number" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_work_telephone_number }}
                        </small>

                        <!-- Salary Day -->
                        <label for="salary_day" class="fw-bold text-xs text-start d-block mt-3">Salary Day
                            <span class="text-danger">*</span>
                        </label>
                        <input v-model="client_salary_day" type="number"
                            class="form-control rounded-small shadow-sm w-100" id="client_salary_day"
                            placeholder="Day of month (1-31)" min="1" max="31" step="1" @blur="validate_salary_day"/>
                        <small v-if="error_messages.client_salary_day" class="form-text text-danger text-xs fw-bold">
                            {{ error_messages.client_salary_day }}
                        </small>
                    </div>
                </div>

                <div class="mb-4 p-3 border rounded shadow-sm" v-if="is_employed">
                    <!-- Employment Address Section -->
                    <h5 class="fw-bold mb-3">Employment Address</h5>

                    <!-- Address Line 1 -->
                    <label for="address_line1" class="fw-bold text-xs text-start d-block mt-3">Address Line 1
                        <span class="text-danger">*</span>
                    </label>
                    <input v-model="client_employment_address_1" type="text"
                        class="form-control rounded-small shadow-sm w-100" id="address_line1"
                        placeholder="Enter address line 1" maxlength="50"/>
                    <small v-if="error_messages.client_employment_address_1" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_address_1 }}
                    </small>

                    <!-- Address Line 2 -->
                    <label for="address_line2" class="fw-bold text-xs text-start d-block mt-3">Address Line 2</label>
                    <input v-model="client_employment_address_2" type="text"
                        class="form-control rounded-small shadow-sm w-100" id="address_line2"
                        placeholder="Enter address line 2 (optional)" maxlength="50" />
                    <small v-if="error_messages.client_employment_address_2" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_address_2 }}
                    </small>

                    <!-- Suburb -->
                    <label for="employment_suburb" class="fw-bold text-xs text-start d-block mt-3">Suburb
                        <span class="text-danger">*</span>
                    </label>
                    <div class="position-relative">
                        <input v-model="employment_suburb_search" type="text" class="form-control rounded-small shadow-sm w-100"
                            id="employment_suburb" placeholder="Type to search suburb..." maxlength="50" required
                            @input="search_employment_postal_codes"
                            @blur="hide_employment_dropdown"
                            autocomplete="off" />
                        <div v-if="employment_search_loading" class="position-absolute end-0 top-50 translate-middle-y me-2">
                            <span class="spinner-border spinner-border-sm text-muted" role="status"></span>
                        </div>
                        <ul v-if="employment_show_dropdown && employment_postal_code_results.length > 0" 
                            class="list-group position-absolute w-100 shadow-sm dropdown-list">
                            <li v-for="result in employment_postal_code_results" :key="result.id"
                                class="list-group-item list-group-item-action text-xs py-2 dropdown-item-clickable"
                                @mousedown.prevent="select_employment_postal_code(result)">
                                <strong>{{ result.suburb }}</strong> - {{ result.postal_code }}
                            </li>
                        </ul>
                    </div>
                    <input type="hidden" v-model="client_employment_suburb" />
                    <small v-if="error_messages.client_employment_suburb" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_suburb }}
                    </small>

                    <!-- City/Town -->
                    <label for="city" class="fw-bold text-xs text-start d-block mt-3">City/Town
                        <span class="text-danger">*</span>
                    </label>
                    <input v-model="client_employment_city" type="text"
                        class="form-control rounded-small shadow-sm w-100" id="city" placeholder="Enter city or town"
                        maxlength="50" />
                    <small v-if="error_messages.client_employment_city" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_city }}
                    </small>

                    <!-- Post Code -->
                    <label for="employment_postcode" class="fw-bold text-xs text-start d-block mt-3">Post Code
                        <span class="text-danger">*</span>
                    </label>
                    <input v-model="client_employment_post_code" type="text" class="form-control rounded-small shadow-sm w-100 bg-light"
                        id="employment_postcode" placeholder="Auto-filled from suburb selection" maxlength="10" required readonly />
                    <small class="form-text text-muted text-xs">Post code is automatically filled when you select a suburb.</small>
                    <small v-if="error_messages.client_employment_post_code" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_post_code }}
                    </small>

                    <!-- Province -->
                    <label class="fw-bold text-xs text-start d-block mt-3">Province
                        <span class="text-danger">*</span>
                    </label>
                    <select v-model="client_employment_province" class="form-select rounded-small text-xs">
                        <option value="" selected disabled hidden>Select Province</option>
                        <option v-for="province in province_options" :key="province.value" :value="province.value">
                            {{ province.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_employment_province" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_province }}
                    </small>

                    <!-- Country -->
                    <label for="client_employment_country" class="fw-bold text-xs text-start d-block mt-3">Country 
                        <span class="text-danger">*</span>
                    </label>
                    <select v-model="client_employment_country" class="form-select rounded-small shadow-sm w-100"
                        id="client_employment_country" required>
                        <option value="" disabled selected hidden>Select country</option>
                        <option v-for="country in country_options" :key="country.value" :value="country.value">
                            {{ country.label }}
                        </option>
                    </select>
                    <small v-if="error_messages.client_employment_country" class="form-text text-danger text-xs fw-bold">
                        {{ error_messages.client_employment_country }}
                    </small>
                </div>

                <div v-if="!is_employed" class="mt-3">
                    <span class="text-muted text-xs">
                        Employment details are not required as you selected
                        {{
                            typeof client_employment_type === 'string' && client_employment_type
                                ? client_employment_type.toLowerCase()
                                : ''
                        }}.
                    </span>
                </div>
            </div>
        </div>

        <div class="text-center mb-3 mt-4">
            <button type="button" @click="$emit('previous')" class="btn btn-bg-secondary text-xs fw-bold rounded-small shadow-sm me-1">
                Previous
            </button>
            <button class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
                @click="submit_employment_details">
                Continue
            </button>
        </div>
    </div>
</div>